module.exports = __webpack_public_path__ + "static/media/openfactor.a0777261.png";